import React from "react";
import { Outlet } from "react-router-dom";
import CustomerSideNav from "../components/CustomerSideNav";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CustomerLayout({ language, dir = "ltr", currentLangFunc, currentDir }) {
  return (
    <div className="mx-auto" dir={`${dir}`}>
      <ToastContainer />
      <CustomerSideNav
        lang={language}
        dirFormat={dir}
        currentLangFunc={currentLangFunc}
        currentDir={currentDir}
      />
      <main className={`main ${dir === "rtl" ? "main-right" : "main-left"}`}>
        <Outlet />
      </main>
    </div>
  );
}

export default CustomerLayout;
